module.exports = __webpack_public_path__ + "static/media/first-lithonia-medical-center-comparison-of-normal-heart-and-coronary-artery-disease.57326937.png";